<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "LMCVReport"
}
</script>

<style scoped>

</style>